import React, { useEffect, useState } from "react";
import axios from "axios";
import Breadcrumbs from "common/Breadcrumbs/Breadcrumbs";
import { routeConstants } from "navigation/routeConstants";
import DocumentArchieveItem from "common/DocumentArchieveItem/DocumentArchieveItem";
import { serviceConfig } from "configs"; // Make sure to import your configuration
import { useNavigate } from "react-router-dom";
import { Input } from "common/Input/Input";

const breadcrumbItems = [
	{ label: "Resminama arhiwi", path: routeConstants.root.route },
	{ label: "Ýapylan içki iberilen hatlar" },
];

const DocumentArchiveClosedSendingPage: React.FC = (): JSX.Element => {
	const navigate = useNavigate();
	const [archivedLetters, setArchivedLetters] = useState<any>([]);
	const [yearFilter, setYearFilter] = useState<string>("");
	console.log("Hellow", archivedLetters);

	useEffect(() => {
		fetchArchivedLetters();
	}, [yearFilter]);

	const fetchArchivedLetters = async () => {
		try {
			const response = await axios.post(`${serviceConfig.apiUrl}/archieves`, {
				letterType: "IIH",
				year: yearFilter || undefined,
			});
			setArchivedLetters(response.data.archivedLetters);
		} catch (error) {
			console.error("Error fetching archived letters:", error);
		}
	};

	const handleClick = (id: string) => {
		navigate(`${routeConstants.documentArchiveClosedSending.route}/${id}`);
	};

	const formatDate = (dateString: string) => {
		const date = new Date(dateString);
		return `${date.getDate().toString().padStart(2, "0")}.${(
			date.getMonth() + 1
		)
			.toString()
			.padStart(2, "0")}.${date.getFullYear()}`;
	};

	const handleYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setYearFilter(e.target.value);
	};
	return (
		<>
			<div className="grid grid-flow-row auto-rows-max pb-7 gap-6 px-6 pt-6 min-h-[90vh]">
				<Breadcrumbs items={breadcrumbItems} />
				<div className="grid grid-cols-1 place-items-end">
					<Input
						type="text"
						id="yearFilter"
						value={yearFilter}
						onChange={handleYearChange}
						placeholder="Ýyl boýunça filter"
						appearance="default"
						name="yearFilter"
						minWidth={true}
						minWidthValue="min-w-[14rem]"
					/>
				</div>
				<div className="grid gap-6 lg:grid-cols-4 TwoXl:grid-cols-5">
					{archivedLetters.map((item: any, idx: number) => (
						<DocumentArchieveItem
							key={idx}
							name={
								item.letterId.status === "Familiarization"
									? "Tanyşdyryş"
									: item.letterId.status === "Execution"
									? "Ýerine ýetirmek"
									: ""
							}
							quantity={item.letterId.files?.length}
							date={formatDate(item.createdAt)}
							onClick={() => handleClick(item._id)}
						/>
					))}
				</div>
			</div>
		</>
	);
};

export default DocumentArchiveClosedSendingPage;
